import request from '@/utils/request'
import {applicationName} from '@/utils/const.js'
export function login(username,password){
  let userInfo = {
    username:username,
    password:password
  }
  return request({
    url:applicationName+'/login',
    method:'POST',
    headers:{
      "Content-Type":"application/json;charset=utf-8"
    },
    data:JSON.stringify(userInfo)
  })
}
